import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export abstract class FireflyNumberFormattingService {
  formatNumber(n: number): Observable<string> {
    return of(n.toLocaleString());
  }
}
